import useWindowDimensions from "@hsl/core/hooks/useWindowDimensions";

function useIsXS() {
    const { width } = useWindowDimensions();

    return width < 375;
}

export default useIsXS;
